import React from 'react'
import './Certifications.css'

// ─────────────────────────────────────────────────────────────────────────────
// Third-Party Certifications page
// Coming-soon state — purchase flow wired when content ships
// Flip CERTS_LIVE to true per cert when content is ready
// ─────────────────────────────────────────────────────────────────────────────

const CERTS_LIVE = false // flip to true when first cert package ships

const CERTS = [
  {
    id:       'comptia_a',
    vendor:   'CompTIA',
    name:     'CompTIA A+',
    badge:    'Most popular',
    desc:     'The industry-standard entry-level IT certification. Covers hardware, networking, troubleshooting, OS, security, and operational procedures. Required or preferred by most helpdesk and support roles.',
    modules:  ['Hardware & components', 'Networking fundamentals', 'Operating systems', 'Security', 'Troubleshooting', 'Operational procedures'],
    exams:    '2 exams (Core 1 + Core 2)',
    price:    '€24.99',
  },
  {
    id:       'comptia_network',
    vendor:   'CompTIA',
    name:     'CompTIA Network+',
    badge:    null,
    desc:     'Validates the networking skills required to support the growing number of connected devices. Covers infrastructure, operations, security, troubleshooting, and network tools.',
    modules:  ['Network architecture', 'Network operations', 'Network security', 'Network troubleshooting', 'Network tools'],
    exams:    '1 exam (N10-009)',
    price:    '€24.99',
  },
  {
    id:       'comptia_security',
    vendor:   'CompTIA',
    name:     'CompTIA Security+',
    badge:    null,
    desc:     'The baseline cybersecurity certification. Covers threats, vulnerabilities, risk management, cryptography, identity management, and network and host security.',
    modules:  ['Threats & attacks', 'Technologies & tools', 'Architecture & design', 'Identity & access', 'Risk management', 'Cryptography'],
    exams:    '1 exam (SY0-701)',
    price:    '€24.99',
  },
  {
    id:       'itil4',
    vendor:   'Axelos',
    name:     'ITIL 4 Foundation',
    badge:    null,
    desc:     'The entry point to ITIL 4. Covers the key concepts of IT and digital service management, the four dimensions model, the service value system, and the 34 ITIL practices.',
    modules:  ['Key concepts', 'Four dimensions', 'Service value system', 'ITIL practices', 'Service value chain'],
    exams:    '1 exam (40 questions)',
    price:    '€24.99',
  },
  {
    id:       'az900',
    vendor:   'Microsoft',
    name:     'AZ-900 Azure Fundamentals',
    badge:    null,
    desc:     'Foundational-level knowledge of cloud services and Microsoft Azure. No technical background required — covers cloud concepts, Azure services, security, privacy, pricing, and support.',
    modules:  ['Cloud concepts', 'Azure architecture', 'Azure services', 'Security & compliance', 'Pricing & support'],
    exams:    '1 exam (AZ-900)',
    price:    '€24.99',
  },
  {
    id:       'aws_ccp',
    vendor:   'Amazon Web Services',
    name:     'AWS Cloud Practitioner',
    badge:    null,
    desc:     'Foundational understanding of AWS Cloud concepts, services, security, architecture, pricing, and support. The starting point for any AWS certification pathway.',
    modules:  ['Cloud concepts', 'AWS services', 'Security & compliance', 'AWS pricing', 'Architecture best practices'],
    exams:    '1 exam (CLF-C02)',
    price:    '€24.99',
  },
]

export function Certifications() {
  return (
    <div className="certs-page">
      <div className="certs-header">
        <div className="certs-header__eyebrow mono">Add-on packages</div>
        <h1 className="certs-header__title">Third-Party Certifications</h1>
        <p className="certs-header__sub">
          Certification prep as a one-time purchase — €24.99 per package, yours while your subscription is active.
          TechBench is not affiliated with any certification vendor. Book your exam directly with the relevant body.
        </p>
      </div>

      {!CERTS_LIVE && (
        <div className="certs-coming-banner">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>Certification prep packages are in development. They ship after Foundation reaches full capacity — Infrastructure tree first.</span>
        </div>
      )}

      <div className="certs-grid">
        {CERTS.map(cert => (
          <CertCard key={cert.id} cert={cert} live={CERTS_LIVE} />
        ))}
      </div>

      <div className="certs-disclaimer mono">
        TechBench is not affiliated with, endorsed by, or authorised by CompTIA, Axelos, Microsoft, or Amazon Web Services.
        Certification names and logos are the property of their respective owners.
        Purchasing a prep package does not register you for an exam.
      </div>
    </div>
  )
}

function CertCard({ cert, live }) {
  return (
    <div className={`cert-card ${live ? '' : 'cert-card--soon'}`}>
      {cert.badge && (
        <div className="cert-card__badge">{cert.badge}</div>
      )}
      <div className="cert-card__vendor mono">{cert.vendor}</div>
      <div className="cert-card__name">{cert.name}</div>
      <div className="cert-card__desc">{cert.desc}</div>

      <div className="cert-card__modules">
        {cert.modules.map(m => (
          <span key={m} className="cert-card__module mono">{m}</span>
        ))}
      </div>

      <div className="cert-card__footer">
        <div className="cert-card__meta mono">{cert.exams}</div>
        <div className="cert-card__price">{cert.price}</div>
      </div>

      {live ? (
        <button className="cert-card__cta">
          Unlock — {cert.price}
        </button>
      ) : (
        <button className="cert-card__cta cert-card__cta--soon" disabled>
          Coming soon
        </button>
      )}

      <div className="cert-card__note mono">
        One-time purchase · Requires active subscription
      </div>
    </div>
  )
}
